// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("./IconV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");
let VisuallyHidden = require("@reach/visually-hidden").default;

function FilterChip(props) {
  let closeHandler = props.closeHandler;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.children
      }),
      closeHandler !== undefined ? JsxRuntime.jsxs(ReactAriaComponents.Button, {
          children: [
            JsxRuntime.jsx(VisuallyHidden, {
              children: "Remove"
            }),
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "cancel-circled",
                className: "text-zinc-600"
              }),
              "aria-hidden": true,
              className: "flex ml-2.5 rounded-full outline outline-tan-blue-500 outline-0 group-focus-visible:outline-2 group-data-[focus-visible]:outline-2"
            })
          ],
          className: param => "group appearance-none bg-transparent border-0 p-0 m-0 inline-flex items-center rounded focus:outline-none",
          onClick: param => closeHandler()
        }) : null
    ],
    className: "inline-flex items-center text-base leading-none py-1.5 pl-2 pr-1.5 rounded-2xl border border-zinc-300 bg-zinc-100 text-zinc-500 whitespace-nowrap"
  });
}

function FilterChip$Group(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let items = React.Children.toArray(props.children);
  return JsxRuntime.jsx("ul", {
    children: items.map(child => JsxRuntime.jsx("li", {
      children: child,
      className: "flex mb-2 mr-2 last:mr-0"
    })),
    "aria-label": props.ariaLabel,
    className: TailwindMerge.twMerge([
      "flex flex-wrap mt-2",
      className
    ])
  });
}

let Group = {
  make: FilterChip$Group
};

let make = FilterChip;

exports.make = make;
exports.Group = Group;
/* react Not a pure module */
